import { DataSyncReconnectionConfig } from '../integrations/DataSync/DataSyncReconnectionConfig';
import { DashworksReconnectionConfig } from '../integrations/Dashworks/DashworksReconnectionConfig';
import { getReconnectionConfigByAppId } from '../reconnectionConfigs';
import { OAuthReconnectionConfig } from '../integrations/OAuthIntegrations/OAuthReconnectionConfig';
export const getReconnectionConfig = ({
  appId,
  isDataSyncApp,
  isDashworksApp,
  hasUrl
}) => {
  const reconnectionConfig = getReconnectionConfigByAppId(appId);
  if (reconnectionConfig) {
    return reconnectionConfig;
  } else if (isDataSyncApp) {
    return DataSyncReconnectionConfig;
  } else if (isDashworksApp) {
    return DashworksReconnectionConfig;
  } else if (hasUrl) {
    return OAuthReconnectionConfig;
  } else {
    return null;
  }
};